export default __webpack_public_path__ + "media/color/qsp-f028343c.svg";